export default ({ request }) => ({
    // 我的供应商名片相关接口
    scmInfoUserContactsListApi(data) {
      return request({
        url: '/digitalCenter/scmInfoUserContacts/myCardList',
        method: 'post',
        data
      })
    },
    scmInfoUserContactsSaveApi(data) {
        return request({
          url: '/digitalCenter/scmInfoUserContacts/save',
          method: 'post',
          data
        })
      },
    scmInfoUserContactsDetailApi(data) {
        return request({
            url: '/digitalCenter/scmInfoUserContacts/detail',
            method: 'post',
            data
        })
    },
    scmInfoUserContactsDelApi(data) {
        return request({
            url: '/digitalCenter/scmInfoUserContacts/del',
            method: 'post',
            data
        })
    },
  })
